import { createRouter, createWebHistory } from 'vue-router';
import InteractiveSolutionExplorer from './InteractiveSolutionExplorer.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: []
});

bootVue('.vue-interactive-solution-explorer', InteractiveSolutionExplorer, {
  jsonProps: ['solutions'],
  beforeMount: (el, props) => {
    
  },
  createAppWrapper: (wrapped, props) => {
    const app = createApp(wrapped, props);
    app.use(router);
    return app;
  }
});
